import React from 'react';
import { ArrowRight, ClipboardList, CreditCard, LogOut, ShieldCheck, UserRound } from 'lucide-react';
import { ASSESSMENT_STATUSES, assessmentStatusLabels } from '../services/assessmentService';

const UserDashboard = ({ user, onLogout, onChoosePlan, onCompletePayment, onAssessmentSetup }) => {
  const selectedPlan = user?.selectedPlan;
  const paymentCompleted = user?.paymentStatus === 'completed';
  const assessmentStatus = user?.assessmentStatus || ASSESSMENT_STATUSES.notStarted;
  const assessmentStartedOnPartner = assessmentStatus === ASSESSMENT_STATUSES.redirectedToPartner || assessmentStatus === ASSESSMENT_STATUSES.inProgress;
  const assessmentLabel = assessmentStartedOnPartner
    ? 'Assessment in progress on partner platform'
    : assessmentStatusLabels[assessmentStatus] || 'Not Started';
  const statusCards = [
    ['Plan', selectedPlan?.name || 'Not selected', selectedPlan ? 'Your chosen MindVrik plan is saved.' : 'Choose a plan to continue.', <ClipboardList size={18} />],
    ['Payment', paymentCompleted ? 'Completed' : 'Pending', paymentCompleted && user?.paymentDate ? `Paid on ${new Date(user.paymentDate).toLocaleDateString()}` : 'Complete payment to unlock assessment.', <CreditCard size={18} />],
    ['Assessment', paymentCompleted ? assessmentLabel : 'Locked', paymentCompleted ? 'Use Start Assessment to continue on the secure partner platform.' : 'Payment completion is required first.', <ShieldCheck size={18} />],
  ];

  return (
    <section className="user-dashboard-page" aria-label="MindVrik dashboard">
      <div className="user-dashboard-shell">
        <div className="dashboard-hero-card">
          <div>
            <div className="section-label">Protected Dashboard</div>
            <h1>Welcome, {user?.role === 'parent' ? user?.parentName : user?.studentName}</h1>
            <p>
              Your MindVrik account is ready. After payment, you can securely continue to the assessment partner platform.
              Assessment reports remain available on the partner platform.
            </p>
          </div>
          <div className="dashboard-user-pill">
            <UserRound size={18} />
            <span>{user?.role}</span>
          </div>
        </div>

        <div className="dashboard-status-grid">
          {statusCards.map(([title, status, desc, icon]) => (
            <div className="dashboard-status-card" key={title}>
              {icon}
              <span>{title}</span>
              <strong>{status}</strong>
              <p>{desc}</p>
            </div>
          ))}
        </div>

        <div className="dashboard-action-row">
          {!selectedPlan && (
            <button className="btn-primary" onClick={onChoosePlan}>Choose Plan <ArrowRight size={15} /></button>
          )}
          {selectedPlan && !paymentCompleted && (
            <>
              <button className="btn-primary" onClick={onCompletePayment}>Complete Payment <ArrowRight size={15} /></button>
              <button className="btn-ghost" onClick={onChoosePlan}>Change Plan</button>
            </>
          )}
          {paymentCompleted && !assessmentStartedOnPartner && (
            <button className="btn-primary" onClick={onAssessmentSetup}>Start Assessment <ArrowRight size={15} /></button>
          )}
          {paymentCompleted && assessmentStartedOnPartner && (
            <button className="btn-primary" onClick={onAssessmentSetup}>Continue Assessment <ArrowRight size={15} /></button>
          )}
          <button className="btn-ghost" onClick={onLogout}><LogOut size={15} /> Logout</button>
        </div>
      </div>
    </section>
  );
};

export default UserDashboard;
